<template>
  <v-container class="py-6">
    <LocaleSwitcher />
    <v-sheet
      class="mx-auto my-5"
      max-width="95%"
    >
      <div
        v-if="loading === true"
        class="text-center"
      >
        <v-progress-circular
          :size="70"
          :width="10"
          color="blue"
          indeterminate
        />
        <br>
        {{ $t("お客様の情報を確認中です。処理が完了するまでお待ちください。") }}
      </div>
    </v-sheet>

    <div
      v-if="loading === false && clinic"
      class="text-center"
    >
      <h3>{{ order.clinic_name }} {{ $t("購入手続き") }}</h3>
      <v-alert
        v-if="order.is_coupon"
        style="background-color: coral"
        type="success"
      >
        {{ order.coupon.value }}{{ order.coupon.type
        }}{{ $t("割引クーポン適用中") }}
      </v-alert>

      <v-alert
        v-if="order.is_firstcoupon"
        style="background-color: coral; margin: 10px"
        type="success"
      >
        {{ $t("初めて割引") }}{{ order.discount }}{{ $t("円分適用中") }}
      </v-alert>

      <template>
        <div>
          <v-alert
            :value="alert"
            color="red"
            type="success"
          >
            {{ alert_meeage }}
          </v-alert>
        </div>
      </template>
      <form-wizard
        v-if="order"
        ref="wizard"
        shape="circle"
        color="#20a0ff"
        error-color="#ff4949"
        title=""
        subtitle=""
        :next-button-text="$t('次へ')"
        :back-button-text="$t('戻る')"
        :finish-button-text="$t('お支払い画面を表示')"
        @on-complete="gmo_payment"
      >
        <!-- 入力タブ -->
        <tab-content
          :title="$t('ご発送先')"
          :before-change="() => beforeTabSwitch(1)"
        >
          <v-row v-if="address !== undefined">
            <v-col>
              {{ $t("発送先履歴で入力") }}
              <v-list-item
                v-for="temp_address in address"
                :key="temp_address.id"
                @click="select_address(temp_address)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-home</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  {{ temp_address.name }} {{ $t("様") }}<br>
                  {{ temp_address.postcode }}
                  {{ temp_address.address }}
                </v-list-item-content>
                <v-list-item-icon @click="delete_address(temp_address)">
                  <v-icon>mdi-delete</v-icon>
                </v-list-item-icon>
              </v-list-item>
              <v-divider />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span class="small-text">{{
                $t("郵便番号で住所を検索します")
              }}</span>
              <v-text-field
                v-model="postcode"
                :rules="[]"
                :label="$t('郵便番号 例0001234')"
                class="inputPostcode"
                autofocus
                outlined:
                true
                counter="7"
                prepend-inner-icon="mdi-home-search-outline"
                type="number"
              />
              <div
                v-if="is_not_found"
                class="v-messages__message"
              >
                {{
                  $t("住所が見つかりません。郵便番号を正しく入力してください")
                }}
              </div>
              <vue-form-generator
                v-if="is_address"
                :schema="address_schema"
                :model="address_model"
                :options="formOptions"
              />
              <div v-if="is_address">
                <v-btn
                  outlined
                  color="success"
                  elevation="2"
                  @click="address_increment()"
                >
                  <v-icon left>
                    mdi-account-plus-outline
                  </v-icon>
                  {{ $t("住所を登録") }}
                </v-btn>

                <div class="small-text">
                  {{
                    $t(
                      "「住所を登録」いただくと、次回購入の際に再入力の必要がありません"
                    )
                  }}
                </div>
              </div>
            </v-col>
          </v-row>
          <div
            v-if="loading === true"
            class="text-center"
          >
            <v-progress-circular
              :size="70"
              :width="10"
              color="blue"
              indeterminate
            />
            <br>
            {{
              $t("お客様の情報を確認中です。処理が完了するまでお待ちください。")
            }}
          </div>
        </tab-content>
        <!-- 確認タブ -->
        <tab-content
          :title="$t('ご確認')"
          :before-change="() => beforeTabSwitch(2)"
        >
          {{ $t("ご確認ください") }}
          <v-simple-table>
            <tr>
              <td>{{ $t("お宛名") }}</td>
              <td>{{ address_model.name }}</td>
            </tr>
            <tr>
              <td>{{ $t("郵便番号") }}</td>
              <td>{{ address_model.postcode }}</td>
            </tr>
            <tr>
              <td>{{ $t("ご住所") }}</td>
              <td>{{ address_model.address }}</td>
            </tr>
            <tr>
              <td>{{ $t("メールアドレス") }}</td>
              <td>{{ address_model.email }}</td>
            </tr>
            <tr>
              <td>{{ $t("携帯電話") }}</td>
              <td>{{ address_model.cellnumber }}</td>
            </tr>

            <tr v-if="delivery_method_model.delivery_method !== ''">
              <td>{{ $t("送付方法") }}</td>
              <td>{{ delivery_method_model.delivery_method }}</td>
            </tr>

            <tr v-if="maker_model.delivery">
              <td>{{ $t("届け先区分") }}</td>
              <td>{{ maker_model.delivery }}</td>
            </tr>

            <tr v-if="maker_model.arrival_time">
              <td>{{ $t("時間帯") }}</td>
              <td>{{ maker_model.arrival_time }}</td>
            </tr>
          </v-simple-table>

          <v-divider />
          <p>{{ $t("ご注文内容") }}</p>

          <v-list two-line>
            <v-list-item
              v-for="item in order.care_items"
              :key="item.id"
              class="align-start list-item-with-border"
            >
              <v-list-item-avatar
                tile
                size="80"
              >
                <v-img :src="item.image || fallbackImage" />
              </v-list-item-avatar>
              <v-list-item-title>
                <b>{{ item.price_normal_name }}</b>
                {{ item.price }}円 {{ item.quantity }}個
              </v-list-item-title>
            </v-list-item>
          </v-list>
          <span v-if="order.delivery_fee != 0">
            {{ $t("発送料") }}:{{ order.delivery_fee.toLocaleString() }}
            {{ $t("円") }}
          </span>
          <span v-if="order.delivery_fee == 0">
            {{ $t("送料無料") }}
          </span>
          <h3>
            {{ $t("合計") }}:{{ order.toral_price.toLocaleString() }}
            {{ $t("円（税込）") }}
          </h3>
          <h3
            v-if="order.is_coupon"
            class="red--text text--lighten-1 ma-5"
          >
            <span v-if="order.coupon.type == '%'">
              {{ discount.toLocaleString() }}{{ $t("円割引") }}
              {{ order.coupon.value }}%OFF
            </span>
            <span v-if="order.coupon.type == '円'">
              {{ order.coupon.value }}{{ $t("割引クーポン適用中") }}
            </span>
          </h3>

          <v-chip
            v-if="order.is_coupon"
            class="ma-2"
            style="background-color: coral; color: white"
            large
            label
            text-color="white"
          >
            <v-icon
              left
              color="white"
            >
              mdi-label
            </v-icon>
            {{ order.coupon.value }}{{ order.coupon.type
            }}{{ $t("割引クーポン適用") }}
            <span
              v-if="order.coupon.type == '%'"
            >&nbsp;{{ order.discount.toLocaleString() }}{{ $t("円") }}{{ $t("割引中") }}</span>
          </v-chip>
        </tab-content>
        <!-- 支払いタブ-->
        <tab-content :title="$t('お支払い')">
          <v-card>
            <v-card-text>
              <h2>{{ $t("お支払い") }}</h2>
            </v-card-text>
            <v-card-text v-if="!is_payment_error">
              <p>
                {{ $t("お支払いは各種クレジットカードがご利用いただけます。") }}
              </p>
              {{ $t("決済代行サービス") }}: {{ clinic.payment_method }}<br>
              {{
                $t(
                  "決済画面から決済方法を選択し決済を完了後、「サイトに戻る」ボタンでお戻りください。"
                )
              }}<br>
            </v-card-text>

            <v-card-text
              v-if="is_payment_error"
              class="v-messages__message"
            >
              <p>
                {{ $t("決済サービスの準備が完了していません。") }}
              </p>
              {{ $t("決済代行サービス") }}: {{ clinic.payment_method }}<br>
              {{ $t("「サイトに戻る」ボタンでお戻りください。") }}<br>
            </v-card-text>

            <div
              v-if="loading === true"
              class="text-center"
            >
              <v-progress-circular
                :size="70"
                :width="10"
                color="blue"
                indeterminate
              />
              <br>
              {{
                $t(
                  "お客様の情報を確認中です。処理が完了するまでお待ちください。"
                )
              }}
            </div>
          </v-card>
        </tab-content>
      </form-wizard>
      <v-btn
        outlined
        color="indigo"
        elevation="2"
        large
        @click="go_priscription()"
      >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        {{ $t("処方箋へ戻る") }}
      </v-btn>
    </div>
  </v-container>
</template>

<script>
/* eslint-disable */
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { GoqZipCode } from "goqzipcode";
import address from "@/mixins/address";
import maker from "@/mixins/maker";
import delivery from "@/mixins/delivery_method";
import paymentForm from "./paymentForm.vue";
import LocaleSwitcher from "@/components/LocaleSwitcher";
VueFormGenerator.validators.resources.fieldIsRequired = "必須項目です。";
import { Firebase } from "../config/firebase";

//component javascript
export default {
  name: "Checkout",
  mixins: [address, maker, delivery],
  components: {
    "vue-form-generator": VueFormGenerator.component,
    FormWizard,
    TabContent,
    paymentForm,
    order: {},
    LocaleSwitcher,
  },
  data() {
    return {
      loading: true,
      loading_customer: true,
      is_payment_error: false,
      alert_meeage: "",
      is_checkout: true,
      is_arrival_time: true,
      alert: false,
      alert_meeage: "",
      postcode: "",
      delivery_method_names: [],
      msg: "Welcome to Your Vue.js App",
      checkout: false,
      showModal: false,
      goqZipCode: new GoqZipCode(),
      valid: false,
      is_address: false,
      is_not_found: false,
      seller: {},
      makers: [],
      r_manufacture: null,
      l_manufacture: null,
      order: null,
      clinic: null,
      user: null,
      address: [],
    };
  },
  computed: {
    user_id() {
      return this.$store.getters.user.uid;
    },
    order_id() {
      return this.$route.params.id;
    },
    clinic_id() {
      return this.order.clinic_id;
    },
    saler_id() {
      return this.order.saler_id;
    },
    patient_id() {
      return this.order.patient_id;
    },
    priscription_id() {
      return this.$route.query.priscription_id;
    },
    l_manufacture_id() {
      return this.order.l_manufacture_id;
    },
    r_manufacture_id() {
      return this.order.r_manufacture_id;
    },

    r_productName() {
      return this.order.r_product_name;
    },
    right_count() {
      return this.order.right_count;
    },
    right_price() {
      return this.order.r_price_sale;
    },

    l_productName() {
      return this.order.l_product_name;
    },
    left_count() {
      return this.order.right_count;
    },
    left_price() {
      return this.order.l_price_sale;
    },
    sub_total_price() {
      return (
        this.left_price * this.left_count + this.right_price * this.right_count
      );
    },
    toral_price() {
      if (this.order.coupon) {
        if (this.order.coupon.type == "円") {
          return this.order.toral_price;
        }
      }
      return this.order.toral_price;
    },
    delivery_fee() {
      let temp_shipping_fee = 0;
      if (this.sub_total_price == 0) {
        temp_shipping_fee = 0;
      } else if (this.sub_total_price < this.clinic.carriage_low) {
        temp_shipping_fee = this.clinic.carriage;
      } else if (this.sub_total_price != 0) {
        let temp_shipping_fee_right = 0;
        let temp_shipping_fee_left = 0;
        let temp_maker_right = "";
        let temp_maker_left = "";
        for (let i = 0; i < this.seller.makers.length; i++) {
          const maker = this.seller.makers[i];
          // 右目の送料をチェック
          if (
            this.r_manufacture.maker_id == maker.name &&
            this.right_count != 0
          ) {
            temp_shipping_fee_right = maker.shipping_fee;
            temp_maker_right = maker.name;
          } // 左目の送料をチェック
          if (
            this.r_manufacture.maker_id == maker.name &&
            this.left_count != 0
          ) {
            temp_shipping_fee_left = maker.shipping_fee;
            temp_maker_left = maker.name;
          }
        }
        if (temp_maker_right != temp_maker_left) {
          temp_shipping_fee = temp_shipping_fee_right + temp_shipping_fee_left;
        } else {
          if (this.right_count != 0) {
            temp_shipping_fee = temp_shipping_fee_right;
          } else if (this.left_count != 0) {
            temp_shipping_fee = temp_shipping_fee_left;
          } else {
            temp_shipping_fee = 0;
          }
        }
      } else {
        temp_shipping_fee = 0;
      }
      return temp_shipping_fee;
    },
    transformed_notice() {
      return this.maker_model.delivery_notice;
    },

    validationErrors() {
      if (this.$refs.form && this.$refs.form.errors) {
        return this.$refs.form.errors;
      }
      return [];
    },
  },
  created: async function () {
    await this.fetchUser();
    await this.fetchOrder();
    await this.fetchClinic();
    await this.fetchSeller();
    await this.fetchPatientAddress();
  },
  mounted: function () {},
  watch: {
    showModal: function () {
      this.$emit("showModal", this.showModal);
    },
    postcode: async function (next, prev) {
      if (prev != null && prev != undefined && prev != "") {
        if (next.length == 7) {
          this.address_model.postcode = next;
          await this.goqZipCode
            .searchAddressFromZipcode({
              zipcode: next,
              is_exact: false,
            })
            .then((result) => {
              let temp_address;
              if (result[0].pref !== undefined) {
                temp_address = result[0].pref;
              }
              if (result[0].city !== undefined) {
                temp_address = temp_address + result[0].city;
              }
              if (result[0].town !== undefined) {
                temp_address = temp_address + result[0].town;
              }
              this.address_model.address = temp_address;
              this.is_address = true;
              this.is_not_found = false;
            })
            .catch((e) => {
              // do failure handling
              this.address_model.address = "該当する住所はありません";
              this.is_address = false;
              this.is_not_found = true;
            });
        }
      }
    },
  },
  methods: {
    requiredRule() {
      return !!this.postcode || "郵便番号は必須です";
    },
    maxLengthRule() {
      return (
        (this.postcode && this.postcode.length <= 7) ||
        '郵便番号は7桁の数字です。"-"ハイフンは不要です'
      );
    },
    go_priscription: function () {
      this.$router.push("/care-items/" + this.order.clinic_id);
    },
    fetchClinic: async function () {
      const clinicRef = await Firebase.firestore()
        .collection("Clinics")
        .doc(this.order.clinic_id);
      await clinicRef
        .get({ source: "server" })
        .catch(() => clinicRef.get())
        .then((doc) => {
          if (doc.exists) {
            this.clinic = doc.data();
            this.clinic.id = doc.id;
          } else {
            console.log("No clinic document!");
          }
          this.error = true;
        });
    },
    fetchSeller: async function () {
      const sellerRef = await Firebase.firestore()
        .collection("Sellers")
        .doc(this.order.saler_id);
      await sellerRef.get().then((doc) => {
        if (doc.exists) {
          this.seller = doc.data();
          this.seller.id = doc.id;
          this.makers = this.seller.makers;
        } else {
          console.log("No Seller document!");
        }
        this.error = true;
      });
    },
    fetchUser: async function () {
      const userRef = Firebase.firestore()
        .collection("Users")
        .doc(this.user_id);
      await userRef.get().then((doc) => {
        if (doc.exists) {
          this.user = doc.data();
          this.user.id = doc.id;
        } else {
          console.log("No user document!");
        }
        this.error = true;
      });
    },
    //Imput Address Method Satrt===================================================
    fetchOrder: async function () {
      const orderRef = await Firebase.firestore()
        .collection("Orders")
        .doc(this.order_id);
      await orderRef.get().then((doc) => {
        if (doc.exists) {
          this.order = doc.data();
          this.order.id = doc.id;
        } else {
          console.log("No order document!");
        }
        this.error = true;
      });

      this.loading = false;
      this.address_model.name = this.order.patient_name;
      this.address_model.cellnumber = this.order.phoneNumber;
      this.address_model.email = this.order.email;
      this.address_model.cellnumber = this.order.cellnumber;
    },
    fetchPatientAddress: async function () {
      this.address = [];
      await Firebase.firestore()
        .collection("Address")
        .where("patientId", "==", this.order.patient_id)
        .orderBy("postcode")
        .get()
        .then((querySnapshot) => {
          if (!querySnapshot.empty) {
            querySnapshot.forEach((doc) => {
              let item = doc.data();
              item.id = doc.id;
              this.address.push(item);
            });
          }
        });
    },
    fetchMakerById: async function (id) {
      const makerRef = await Firebase.firestore().collection("Makers").doc(id);
      await makerRef.get().then((doc) => {
        if (doc.exists) {
          this.maker_model = doc.data();
          this.maker_model.id = doc.id;
        } else {
          console.log("No maker document!");
        }
        this.error = true;
      });
    },

    onComplete: function () {
      this.increment();
    },
    address_increment: async function () {
      if (
        this.address_model.name == "" ||
        this.address_model.address == "" ||
        this.address_model.postcode == "" ||
        this.address_model.email == "" ||
        this.address_model.cellnumber == ""
      ) {
        alert("必須項目に未入力があります");
      } else {
        let temp_address = {
          patientId: this.order.patient_id,
          name: this.address_model.name,
          address: this.address_model.address,
          postcode: this.address_model.postcode,
          email: this.order.email,
          cellnumber: this.address_model.cellnumber,
          status: "allowed",
        };

        await Firebase.firestore()
          .collection("Address")
          .doc()
          .set(temp_address);
        await this.fetchPatientAddress();
      }
    },
    increment: async function () {
      if (
        this.address_model.name == "" ||
        this.address_model.address == "" ||
        this.address_model.postcode == "" ||
        this.address_model.email == "" ||
        this.address_model.cellnumber == "" ||
        this.order.arrival_time == "" ||
        (this.order.delivery == this.maker_model.delivery) == "" ||
        (this.order.delivery_method ==
          this.delivery_method_model.delivery_method) ==
          ""
      ) {
        alert("必須項目に未入力があります");
      } else {
        let temp_address = {
          patientId: this.order.patient_id,
          name: this.address_model.name,
          address: this.address_model.address,
          postcode: this.address_model.postcode,
          email: this.order.email,
          cellnumber: this.address_model.cellnumber,
          status: "allowed",
        };

        await Firebase.firestore()
          .collection("Address")
          .doc()
          .set(temp_address);
        await this.fetchPatientAddress();
      }
    },

    onMakerModelUpdated: function (newVal) {
      for (const element of this.delivery_method_model.delivery_methods) {
        if (element.name === newVal) {
          if (element.is_arrival_at) {
            this.is_arrival_time = true;
          } else {
            this.is_arrival_time = false;
          }
        }
      }
    },
    select_address: function (address) {
      this.address_model.patientId = this.order.patient_id;
      this.address_model.name = address.name;
      this.address_model.postcode = address.postcode;
      this.address_model.address = address.address;
      this.address_model.cellnumber = address.phonenumber;
      this.address_model.cellnumber = address.cellnumber;
      this.is_address = true;
    },
    //Imput Address Method End===================================================
    delete_address: async function (address) {
      const id = address.id;
      await Firebase.firestore()
        .collection("Address")
        .doc(id)
        .delete()
        .then(() => {
          console.log("Document Address successfully deleted!");
        })
        .catch((error) => {
          console.error("Error removing document Address: ", error);
        });

      await this.fetchPatientAddress();
    },
    beforeTabSwitch: async function (value) {
      if (value === 1) {
        let check = true;
        if (this.delivery_method_model.delivery_method !== "") {
          if (
            this.address_model.name == "" ||
            this.address_model.address == "" ||
            this.address_model.postcode == "" ||
            this.address_model.email == "" ||
            this.address_model.cellnumber == "" ||
            this.maker_model.delivery == "" ||
            this.maker_model.arrival_time == "" ||
            this.delivery_method_model.delivery_method == ""
          ) {
            check = false;
          } else {
            this.checkout = true;
            this.order.name = this.address_model.name;
            this.order.address = this.address_model.address;
            this.order.postcode = this.address_model.postcode;
            this.order.cellnumber = this.address_model.cellnumber;
            this.order.email == this.address_model.email;
            this.order.arrival_time = this.maker_model.arrival_time;
            this.order.delivery = this.maker_model.delivery;
            this.order.delivery_method =
              this.delivery_method_model.delivery_method;
            this.order.status = "panding";
            check = true;
          }
        } else {
          if (
            this.address_model.name == "" ||
            this.address_model.address == "" ||
            this.address_model.postcode == "" ||
            this.address_model.email == "" ||
            this.address_model.cellnumber == ""
          ) {
            check = false;
          } else {
            this.checkout = true;
            this.order.name = this.address_model.name;
            this.order.address = this.address_model.address;
            this.order.postcode = this.address_model.postcode;
            this.order.cellnumber = this.address_model.cellnumber;
            this.order.arrival_time = this.maker_model.arrival_time;
            this.order.delivery = this.maker_model.delivery;
            this.order.email == this.address_model.email;
            this.order.delivery_method = "";
            this.order.status = "panding";
            check = true;
          }
        }
        return check;
      } else if (value === 2) {
        return true;
      } else if (value === 3) {
        return true;
      } else if (value === 4) {
        return true;
      }
    },

    check_email() {
      if (this.address_model.email === undefined) {
        alert(
          "1ご連絡先メールアドレスをご入力ください" + this.address_model.email
        );
        return false;
      }
      if (this.address_model.email === null) {
        alert(
          "2ご連絡先メールアドレスをご入力ください" + this.address_model.email
        );
        return false;
      }
      if (this.address_model.email === "") {
        alert(
          "3ご連絡先メールアドレスをご入力ください" + this.address_model.email
        );
        return false;
      }
      var pattern =
        /^[A-Za-z0-9]{1}[A-Za-z0-9_+.-]*@{1}[A-Za-z0-9_.-]+.[A-Za-z0-9]+$/;
      if (pattern.test(this.address_model.email)) {
      } else {
        alert(
          "4メールアドレスを正しくご入力ください" + this.address_model.email
        );
        return false;
      }
      return true;
    },
    /* GMO PAYMENT CREATE LINK */
    async gmo_payment() {
      if (this.check_email(this.customerEmail) == false) {
        return;
      }

      this.loading = true;
      let docData = {
        Amount: this.toral_price,
        total_payment: this.toral_price,
        // CUSTOMER INFO
        patient_id: this.order.patient_id,
        patient_patientNumber: this.order.patientNumber,
        phone_number: this.address_model.cellnumber,
        customerEmail: this.address_model.email,
        customerName: this.address_model.name,
        // ORDER INFO
        order_id: this.order.id,
        priscription_id: "",
        prescription_number: "",
        sales_tax: Math.round(this.toral_price * 0.1),
        // CLINIC INFO
        clinic_id: this.clinic_id,
        clinic_name: this.clinic.name,
        siteUrl: window.location.href,
        RetUrl: window.location.href,
        // DELIIVERY DEVIBARY
        delivery_name: this.address_model.name,
        delivery_address: this.address_model.address,
        delivery_postcode: this.address_model.postcode,
        delivery_cellnumber: this.address_model.cellnumber,
        delivery_arrival_time: this.maker_model.arrival_time,
        delivery_delivery: this.maker_model.delivery,
        delivery_email: this.address_model.email,
        delivery_delivery_method: this.delivery_method_model.delivery_method,
        //delivery_fee: this.delivery_fee,
      };
      this.ensurePaymentContactPayload(docData);
      const paymentMethod = this.clinicPaymentMethod();
      if (paymentMethod == "SQUARE") {
        await Firebase.firestore()
          .collection("Orders")
          .doc(this.order_id)
          .update(docData)
          .then(() => {
            this.$router.push({
              name: "square",
              params: { id: this.order_id },
            });
            return;
          });
      } else if (paymentMethod == "DGFT") {
        await Firebase.firestore()
          .collection("Orders")
          .doc(this.order_id)
          .update(docData);
        this.implemetCollections(docData);
      } else {
        this.implemetCollections(docData);
      }
    },

    ensurePaymentContactPayload(params) {
      params.customerEmail = params.customerEmail || params.delivery_email;
      params.delivery_email = params.delivery_email || params.customerEmail;
      params.phone_number = params.phone_number || params.delivery_cellnumber;
      params.delivery_cellnumber =
        params.delivery_cellnumber || params.phone_number;
      return params;
    },

    clinicPaymentMethod() {
      return this.clinic && this.clinic.payment_method
        ? String(this.clinic.payment_method).trim()
        : "";
    },

    getGmoCollectionFunctionName() {
      const paymentMethod = this.clinicPaymentMethod();
      if (paymentMethod == "GMO") {
        return "gmoCollectionInfo";
      }
      if (paymentMethod == "GMO 3DSv2") {
        return "gmoCollectionInfo3dsV2";
      }
      return null;
    },

    implemetCollections(params) {
      const functions = Firebase.app().functions("asia-northeast1");
      const gmoCollectionFunctionName = this.getGmoCollectionFunctionName();
      if (gmoCollectionFunctionName) {
        console.log("Calling GMO payment function:", gmoCollectionFunctionName);
        const httpEvent = functions.httpsCallable(gmoCollectionFunctionName);
        httpEvent(params)
          .then((res) => {
            this.OrderID = res.data.orderID;
            this.getRetUrl = res.data.resurl;
            window.location.href = this.getRetUrl;
          })
          .catch((error) => {
            // エラーレスポンスが500の場合の処理
            if (
              error.code === "internal" ||
              (error.response && error.response.status === 500)
            ) {
              console.error("Payment error:", error);
              this.loading = false; // ローディングを停止
              this.is_payment_error = true; // 支払いエラーを表示
              alert(
                "エラー：決済画面を表示できません。code: " +
                  res.data.result_code +
                  "サポートに連絡してください。電話：050-3637-3860"
              );
              this.loading = false;
            }
          });
      } else if (this.clinicPaymentMethod() == "STRIPE") {
        const httpEvent = functions.httpsCallable("stripCollectionInfo");
        httpEvent(params)
          .then((res) => {
            this.OrderID = res.data.orderID;
            this.getRetUrl = res.data.resurl;
            window.location.href = this.getRetUrl;
          })
          .catch((error) => {
            // エラーレスポンスが500の場合の処理
            if (
              error.code === "internal" ||
              (error.response && error.response.status === 500)
            ) {
              console.error("Payment error:", error);
              this.loading = false; // ローディングを停止
              this.is_payment_error = true; // 支払いエラーを表示
            }
          });
      } else if (this.clinicPaymentMethod() == "DGFT") {
        const httpEvent = functions.httpsCallable("dgftCollectionInfo");
        httpEvent(params).then((res) => {
          if (res.data.status == "success") {
            this.$router
              .push({
                name: "dgft",
                params: {
                  order_id: this.order_id,
                  payment_key: res.data.payment_key,
                },
              })
              .catch((error) => {
                // エラーレスポンスが500の場合の処理
                if (
                  error.code === "internal" ||
                  (error.response && error.response.status === 500)
                ) {
                  console.error("Payment error:", error);
                  this.loading = false; // ローディングを停止
                  this.is_payment_error = true; // 支払いエラーを表示
                }
              });
          } else {
            alert(
              "エラー：決済画面を表示できません。code: " +
                res.data.result_code +
                "サポートに連絡してください。電話：050-3637-3860"
            );
            this.loading = false;
            //window.location.href = "/";
            return;
          }
        });
      } else {
        console.error("Unsupported payment_method:", this.clinic.payment_method);
        alert(
          "エラー：決済画面を表示できません。サポートに連絡してください。電話：050-3637-3860"
        );
        this.loading = false;
        window.location.href = "/";
        return;
      }
    },
  },
};

/* eslint-enable */
</script>
<style>
.vue-form-generator {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 0;
  padding-top: 0;
}
fieldset {
  border: 1;
  padding: 1em;
  margin: 0.5em;
  width: 100%;
  border-style: solid;
  border-color: rgb(170, 170, 170);
  border-radius: 5px;
}
.small-text {
  font-size: small;
}
.v-messages__message {
  color: red;
}

.inputPostcode {
  margin-bottom: 0;
  padding-bottom: 0;
}
</style>
